module.exports = __webpack_public_path__ + "static/ITCAvantGardeStd-XLt-ea29dc5cc33126fdc5f42de8b9ae6f2a.woff";